(function ($) {
    function checkScrollEnd() {
        let $slider = $('.my-account-template__aside-items');
        let $arrow = $('.my-account-template__aside-items-arrow');
        if (!$slider.length || !$arrow.length) {
            return;
        }
        $arrow.click(function(){
            const scrollLeft = $slider.scrollLeft();
            const scrollWidth = $slider[0].scrollWidth;
            const clientWidth = $slider[0].clientWidth;

            if (scrollLeft + clientWidth >= scrollWidth - 50) {
                $slider.scrollLeft(clientWidth);
            } else {
                $slider.scrollLeft(scrollLeft + 50);
            }
        })
    }

    $(document).gp_ready(function () {
        checkScrollEnd();
    });


})(jQuery);
